module.exports = __webpack_public_path__ + "static/img/bg1@2x.da48250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/bg1@2x.png
// module id = B8Zv
// module chunks = 2